import request from '@/utils/request';

// 获取是否需要补全信息
export function isNeedCompleteApi() {
  return request({
    url: '/maxi-diagnosis-app/v1/unlock/isNeedComplete?unlockPolicyCode=G',
    method: 'get',
  });
}

// 获取需要补全信息列表
export function needCompleteInfoListApi(data) {
  return request({
    url: `/maxi-diagnosis-app/v1/unlock/needCompleteInfoList`,
    method: 'post',
    data,
  });
}

// 保存解锁网关信息
export function saveCompleteInfoApi(data) {
  return request({
    url: `/maxi-diagnosis-app/v1/unlock/saveCompleteInfo`,
    method: 'post',
    data,
  });
}

// 上传附件
export function uploadListApi(data) {
  return request({
    url: `/maxi-diagnosis-app/v1/attachment/upload`,
    method: 'post',
    data,
  });
}

// 获取证件类型列表
export function getCardTypeListApi() {
  return request({
    url: '/maxi-diagnosis-app/v1/unlock/getDropDownValueList?unlockPolicyCode=G&dropDownType=idCardType',
    method: 'get',
  });
}
